export default __webpack_public_path__ + "static/starterPackImg-e7b4b7005b65adc40d2fdb929bf31e07.png";